import React from "react";
import Helping from "../../helpers/Helping";
import Select from '../fields/dropDownWithSelect';
import DropDownAutoFill from '../fields/dropDownAutoFill';
import MultiSelect from '../fields/dropDownWithMultiSelect';

function Filter({ data, classes }) {
    const { inputs } = data;

    return (
        <div id="dropDownFilterId" class={`dropdown ${classes}`}>
            <button class="custom-btn dark-btn icon-btn sm-btn dropdown-toggle" id="filterDropdown" data-toggle="dropdown" data-flip="false" aria-haspopup="true" aria-expanded="false">
                <svg id="Filter" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                    <path id="Shape" d="M8.347,16a.687.687,0,0,1-.4-.126L5.254,13.967a.645.645,0,0,1-.275-.524V10.61A6.169,6.169,0,0,0,3.53,6.657L.371,2.889A1.533,1.533,0,0,1,.127,1.278,1.628,1.628,0,0,1,1.475.3,51.514,51.514,0,0,1,12.526.3a1.627,1.627,0,0,1,1.347.981,1.533,1.533,0,0,1-.245,1.611L10.469,6.657A6.173,6.173,0,0,0,9.021,10.61v4.74a.645.645,0,0,1-.369.58A.7.7,0,0,1,8.347,16ZM7,1.3a50.33,50.33,0,0,0-5.376.289.3.3,0,0,0-.251.183.285.285,0,0,0,.045.3L4.578,5.84a7.443,7.443,0,0,1,1.748,4.77v2.5l1.347.953V10.61A7.443,7.443,0,0,1,9.423,5.84l3.159-3.769a.285.285,0,0,0,.045-.3.3.3,0,0,0-.251-.183A50.33,50.33,0,0,0,7,1.3Z" />
                </svg>

                <span class="txt-btn">Filter</span>
            </button>

            <form id="dropDownFilter" class="dropdown-menu dropdown-menu-right filter-dropdown-menu" aria-labelledby="filterDropdown" onClick={(e) => e.stopPropagation()}>

                {inputs.map(input => {

                    return (() => {
                        switch (input.type) {
                            case 'autoFill':
                                return (
                                    <div class="form-group autofill">
                                        <label for="">{input.label}</label>
                                        <DropDownAutoFill
                                            label={input.label}
                                            field={input.label}
                                            classes="col-xl-2 col-md-4"
                                            valuesArray={input.data}
                                            handleOnSelect={data.handleOnSelect}
                                            handleOnSearch={data.handleOnSearch}
                                            handleFormatResult={data.formatResult}
                                            handleOnClear={data.handleOnClear}
                                            userSelectedFieldValue={input.defaultValue}
                                        />
                                    </div>
                                );

                            case 'textInput':
                                return (
                                    <div class="form-group">
                                        <label for={input.name}>{input.label}</label>
                                        <input type="text" name={input.name} id={input.name} class="form-control" value={input.defaultValue} onChange={(e) => data.handleValueChange(e)} />
                                    </div>
                                );

                            case 'date':
                                return (
                                    <div class="row">
                                        <div class="col-6 pr-2">
                                            <div class="form-group">
                                                <label for="fromDate">From</label>
                                                <input type="date" max={input.maxDate ? input.maxDate : null} name="fromDate" id="fromDate" class="form-control" value={input.startDate} onChange={(e) => data.handleStartDateChange(e)} />
                                            </div>
                                        </div>
                                        <div class="col-6 pl-2">
                                            <div class="form-group">
                                                <label for="toDate">To</label>
                                                <input type="date" max={input.maxDate ? input.maxDate : null} name="toDate" id="toDate" class="form-control" value={input.endDate} onChange={(e) => data.handleEndDateChange(e)} />
                                            </div>
                                        </div>
                                    </div>
                                );

                            case 'dropdown':
                                return (
                                    <div class="form-group">
                                        <label for={input.name}>{input.label}</label>

                                        <select class="form-select" id={input.name} name={input.name}
                                            value={input.defaultValue}
                                            onChange={(e) => data.handleValueChange(e)}>

                                            <option value="" selected>{input.placeholder}</option>
                                            {input.data.map(opt => (
                                                <option value={opt.value}>{Helping.getTitleCase(opt.name)}</option>
                                            ))}
                                        </select>
                                    </div>
                                );

                            case 'multiselect':
                                return (
                                    <div class="form-group">
                                        <label for={input.name}>{input.label}</label>

                                        <MultiSelect name={input.name} field={input.label} id={input.name}
                                            valuesArray={input.data}
                                            callback={data.ref}
                                            userSelectedFieldValue={input.defaultValue}
                                            selectChangeFunction={data.handleMultiSelect}
                                        />
                                    </div>
                                );

                            case 'reactselect':
                                return (
                                    <div class="form-group">
                                        <label for={input.name}>{input.label}</label>
                                        <Select name={input.name} field={input.label} id={input.name}
                                            valueToBeSelectedKey={input.selectedKey}
                                            valueToBeSelected={input.selectedValue}
                                            valuesArray={input.data}
                                            callback={data.ref}
                                            userSelectedFieldValue={input.defaultValue}
                                            selectChangeFunction={data.handleChange}
                                        />
                                        {/* <Select name="owner_id" field="Owners" id="owners"
                                            valueToBeSelectedKey={["username"]}
                                            valueToBeSelected="id"
                                            valuesArray={ownersData}
                                            callback={data.ref}
                                            userSelectedFieldValue={data.owner_id}
                                            selectChangeFunction={data.handleChange}
                                        /> */}
                                    </div>
                                );

                            default:
                                return <></>;
                        }
                    })()
                }
                )}

                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { data.reset(e); window.closeFilterDropdown() }}>Reset</button>
                <button id="applyFilter" class="custom-btn gradiant-btn sm-btn float-right"
                    onClick={(event) => { data.getResults(event); window.closeFilterDropdown(); }}
                >
                    Apply
                </button>
            </form >
        </div >
    )
}

export default Filter;